import {
  doFetchBillingData,
  doFetchInvoices,
  doFetchBillingInformation,
} from 'ducks/billing/operations'
import { doFetchIntegrations } from 'ducks/integrations/operations'
import { doFetchEvents } from 'ducks/events/operations'
import { selectIsDraftDirty } from 'ducks/translations/selectors'
import {
  SETTINGS_PAGE,
  SETTINGS_BILLING_PAGE,
  SETTINGS_BILLING_INVOICES_PAGE,
  SETTINGS_BILLING_INFORMATION_PAGE,
  SETTINGS_COMPANY_BUSINESS_HOURS_PAGE,
  SETTINGS_CRM_PAGE,
  SETTINGS_INTEGRATIONS_PAGE,
  SETTINGS_REPORTS_PAGE,
  SETTINGS_BILLING_ACTIVITY_PAGE,
  SETTINGS_INTEGRATIONS_PROVIDER_PAGE,
  SETTINGS_INTEGRATIONS_ADD_NEW_PAGE,
  SETTINGS_INTEGRATIONS_EDIT_PAGE,
  SETTINGS_WIDGETS_PAGE,
  SETTINGS_WIDGET_PAGE,
  SETTINGS_WIDGET_CUSTOMIZE_PAGE,
  SETTINGS_WIDGET_CONTACT_PAGE,
  SETTINGS_WIDGET_KB_PAGE,
  SETTINGS_WIDGET_CHAT_PAGE,
  SETTINGS_WIDGET_CHAT_CONVERSATION_PAGE,
  SETTINGS_WIDGET_CHAT_ROUTING_PAGE,
  SETTINGS_WIDGET_CHAT_ACL_PAGE,
  SETTINGS_WIDGET_CHAT_BOT_OVERVIEW_PAGE,
  SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_EXISTING_CONVERSATION_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_NEW_CONVERSATION_SKILL_PAGE,
  SETTINGS_WIDGET_CHAT_UNRESPONSIVE_AGENTS_SKILL_PAGE,
  SETTINGS_WIDGET_TRANSLATE_PAGE,
  SETTINGS_WIDGET_INSTALL_PAGE,
  SETTINGS_WIDGET_FIRST_INSTALL_PAGE,
  SETTINGS_WIDGET_CREATE_NEW_PAGE,
  SETTINGS_WIDGET_CREATE_CUSTOMIZE_PAGE,
  SETTINGS_WIDGET_CREATE_INSTALL_PAGE,
  SETTINGS_CANNEDREPLIES_PAGE,
  SETTINGS_FOLDERS_PAGE,
  SETTINGS_RULES_PAGE,
  SETTINGS_USERS_PAGE,
  SETTINGS_TAGS,
  SETTINGS_CHANNELS_PAGE,
  SETTINGS_INTEGRATIONS_V2_PAGE,
} from './types'
// This file is required by core, so to perform
// appropriate bundling, it should not require any
// underlying subapp code

// routes get injecter into rudy
export const routes = {}

// pages get injected into constants
export const pages = {}

// handlers get injected into page reducers
export const handlers = {}

// convenience function to allow defining of
// all 3 required pieces in one go
function register(name, config) {
  pages[name] = name
  routes[name] = config.route
  handlers[name] = config.handler
}

register(SETTINGS_PAGE, {
  route: {
    path: '/settings',
  },
  handler: () => ({
    componentName: 'HomePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_BILLING_PAGE, {
  route: {
    path: '/settings/billing',
    thunk: doFetchBillingData(),
  },
  handler: () => ({
    componentName: 'BillingPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_BILLING_INVOICES_PAGE, {
  route: {
    path: '/settings/billing/invoices',
    thunk: doFetchInvoices(),
  },
  handler: () => ({
    componentName: 'InvoicesPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_BILLING_INFORMATION_PAGE, {
  route: {
    path: '/settings/billing/information',
    thunk: doFetchBillingInformation(),
  },
  handler: () => ({
    componentName: 'BillingInformationPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_BILLING_ACTIVITY_PAGE, {
  route: {
    path: '/settings/billing/activity',
    thunk: doFetchEvents(),
  },
  handler: () => ({
    componentName: 'BillingActivityPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_COMPANY_BUSINESS_HOURS_PAGE, {
  route: {
    path: '/settings/business_hours',
  },
  handler: () => ({
    componentName: 'BusinessHoursPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_INTEGRATIONS_PAGE, {
  route: {
    path: '/settings/integrations',
    thunk: doFetchIntegrations(),
  },
  handler: () => ({
    componentName: 'IntegrationsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGETS_PAGE, {
  route: {
    path: '/settings/integrations/widgets',
  },
  handler: () => ({
    componentName: 'WidgetsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CREATE_NEW_PAGE, {
  route: {
    path: '/settings/integrations/widgets/new',
  },
  handler: () => ({
    componentName: 'WidgetsCreatePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CREATE_CUSTOMIZE_PAGE, {
  route: {
    path: '/settings/integrations/widgets/new/customize',
  },
  handler: () => ({
    componentName: 'WidgetsCreatePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CREATE_INSTALL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/install',
  },
  handler: () => ({
    componentName: 'WidgetsCreatePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id',
  },
  handler: () => ({
    componentName: 'WidgetsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CUSTOMIZE_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/customize',
  },
  handler: () => ({
    componentName: 'WidgetsCustomizePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CONTACT_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/contact',
  },
  handler: () => ({
    componentName: 'WidgetsContactPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_KB_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/kb',
  },
  handler: () => ({
    componentName: 'WidgetsKbPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_CONVERSATION_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/conversations',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_ACL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/access',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_BOT_OVERVIEW_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/bot',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/bot/welcome',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/bot/identity',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_EXISTING_CONVERSATION_SKILL_PAGE, {
  route: {
    path:
      '/settings/integrations/widgets/:id/chat/bot/offlineAgents/existingConversation',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_OFFLINE_AGENTS_NEW_CONVERSATION_SKILL_PAGE, {
  route: {
    path:
      '/settings/integrations/widgets/:id/chat/bot/offlineAgents/newConversation',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_UNRESPONSIVE_AGENTS_SKILL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/bot/unresponsiveAgents',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_TRANSLATE_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/translate',
    confirmLeave: state => {
      if (selectIsDraftDirty(state)) {
        return 'You have unsaved changes on this page. Are you sure?'
      }
      return undefined
    },
  },
  handler: () => ({
    componentName: 'WidgetsTranslatePage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_CHAT_ROUTING_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/chat/routing',
  },
  handler: () => ({
    componentName: 'WidgetsChatPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_INSTALL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/install',
  },
  handler: () => ({
    componentName: 'WidgetsInstallPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_WIDGET_FIRST_INSTALL_PAGE, {
  route: {
    path: '/settings/integrations/widgets/:id/finish-install',
  },
  handler: () => ({
    componentName: 'WidgetsInstallPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_INTEGRATIONS_ADD_NEW_PAGE, {
  route: {
    path: '/settings/integrations/:provider/new',
  },
  handler: () => ({
    componentName: 'IntegrationsAddNewPage',
    subapp: 'settings',
  }),
})
register(SETTINGS_INTEGRATIONS_EDIT_PAGE, {
  route: {
    path: '/settings/integrations/:provider/edit/:id',
  },
  handler: () => ({
    componentName: 'IntegrationsEditPage',
    subapp: 'settings',
  }),
})
register(SETTINGS_INTEGRATIONS_PROVIDER_PAGE, {
  route: {
    path: '/settings/integrations/:provider/:tab?/:id?',
    thunk: doFetchIntegrations(),
  },
  handler: () => ({
    componentName: 'IntegrationsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_REPORTS_PAGE, {
  route: {
    path: '/settings/reports',
  },
  handler: () => ({
    componentName: 'ReportsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_CRM_PAGE, {
  route: {
    path: '/settings/crm/:tab?/:id?/:modal?',
  },
  handler: () => ({
    componentName: 'CrmPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_CANNEDREPLIES_PAGE, {
  route: {
    path: '/settings/canned-replies/:tab?',
  },
  handler: () => ({
    componentName: 'CannedRepliesPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_FOLDERS_PAGE, {
  route: {
    path: '/settings/folders/:tab?',
  },
  handler: () => ({
    componentName: 'FoldersPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_RULES_PAGE, {
  route: {
    path: '/settings/rules/:tab?',
  },
  handler: () => ({
    componentName: 'RulesPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_TAGS, {
  route: {
    path: '/settings/tags/:tab?',
  },
  handler: () => ({
    componentName: 'TagsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_USERS_PAGE, {
  route: {
    path: '/settings/users/:tab?',
  },
  handler: () => ({
    componentName: 'UsersPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_CHANNELS_PAGE, {
  route: {
    path: '/settings/channels/:tab?',
  },
  handler: () => ({
    componentName: 'ChannelsPage',
    subapp: 'settings',
  }),
})

register(SETTINGS_INTEGRATIONS_V2_PAGE, {
  route: {
    path: '/settings/integrations-v2/:tab?',
  },
  handler: () => ({
    componentName: 'IntegrationsV2Page',
    subapp: 'settings',
  }),
})
